import cxs from 'cxs';

import { LABEL_POSITION } from '../constants/labelPosition';

export const LABEL = cxs({
  margin: 0,
  marginBottom: '10px',
  display: 'block'
});

export const LABEL_CONTAINER = (
{ notFullWidth, position }) =>
{
  let positionStyles = {};

  if (position === LABEL_POSITION.TOP) {
    positionStyles = {
      display: 'block'
    };
  } else if (position === LABEL_POSITION.RIGHT) {
    positionStyles = {
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
      '& .text--label': {
        marginLeft: '12px'
      }
    };
  } else if (position === LABEL_POSITION.LEFT) {
    positionStyles = {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    };
  }

  return cxs({
    textAlign: 'left',
    width: notFullWidth ? void 0 : '100%',
    ...positionStyles
  });
};

export const LABEL_HEADER = cxs({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
});

export const HELPER = cxs({
  margin: 0,
  marginTop: '10px',
  display: 'block'
});